import * as yup from 'yup';

const { object, string } = yup;

export type CreateStoragePointFormData = yup.InferType<
  typeof createStoragePointSchema
>;

export const createStoragePointSchema = object({
  name: string().required(),
  locationId: string().required(),
  warehouseId: string().optional(),
});
